import { yupResolver } from '@hookform/resolvers/yup'
import { ControlledSelect, ControlledTextField, stopPropagationSubmitHandler, useTranslatedOptionEnum } from '@if/mui'
import { Stack } from '@mui/material'
import FormDialog from '@src/components/Common/Dialog/FormDialog'
import { getEProductList } from '@src/types/constants'
import { FC } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { DisbursementLineSchema, type DisbursementLineSchemaType } from './loan-form-schema'

interface DisbursementLineDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: (data: DisbursementLineSchemaType) => void
  defaultValues?: DisbursementLineSchemaType
}

const DisbursementLineDialog: FC<DisbursementLineDialogProps> = ({ open, onClose, onSubmit, defaultValues }) => {
  const { t } = useTranslation()
  const { handleSubmit, reset, control } = useForm<DisbursementLineSchemaType>({
    resolver: yupResolver(DisbursementLineSchema),
    defaultValues,
    shouldFocusError: !!defaultValues,
  })

  const productOptions = useTranslatedOptionEnum('enum.product', getEProductList())

  const handleClose = () => {
    reset()
    onClose()
  }

  const onSubmitHandler = (data: DisbursementLineSchemaType) => {
    reset()
    onClose()
    onSubmit(data)
  }

  return (
    <FormDialog
      title={t('loan.fundedProducts')}
      onClose={handleClose}
      onConfirm={stopPropagationSubmitHandler(handleSubmit(onSubmitHandler))}
      open={open}
    >
      <Stack rowGap={2} columnGap={1}>
        <ControlledSelect control={control} name="productId" label={t('loan.product')} options={productOptions} />
        <ControlledTextField
          control={control}
          name="amount"
          label={t('loan.amount')}
          autoFocus={!!defaultValues?.productId}
        />
        <ControlledTextField
          control={control}
          name="description"
          label={t('loan.description')}
          autoFocus={!!defaultValues?.description}
        />
      </Stack>
    </FormDialog>
  )
}

export default DisbursementLineDialog
